export function updateUrl(params) {
  let url = new URL(location.href);
  url.search = new URLSearchParams(params).toString();
  location.href = encodeURI(url);
}
